import Hero from './components/Hero';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryGrid from './components/CategoryGrid';
import LatestArticles from './components/LatestArticles';
import Newsletter from './components/Newsletter';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '亚欧风格志',
  url: 'https://shenshang003.cn',
  description: '亚洲欧美风格融合指南，专注跨文化时尚与生活方式内容创作。探索时尚穿搭、美妆潮流、生活方式等领域的跨文化融合之美。',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://shenshang003.cn/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '亚欧风格志',
  url: 'https://shenshang003.cn',
  description: '亚洲欧美风格融合指南 - 跨文化时尚与生活方式全解析',
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '什么是亚洲欧美风格融合？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '亚洲欧美风格融合是指将亚洲（如中日韩）与欧美（如法意北欧）的时尚、美妆和生活方式元素进行创意混搭，在尊重各自文化本源的基础上，创造出兼具东西方美学的独特个人风格。它不是简单的元素堆砌，而是深入理解两种文化审美逻辑后的有机融合。',
      },
    },
    {
      '@type': 'Question',
      name: '如何在日常穿搭中实现亚洲欧美混搭？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '可以从三个维度入手：材质对话（如日式棉麻搭配意大利羊毛）、比例游戏（宽松韩式廓形搭配紧身法式内搭）、细节融合（西式套装点缀中式盘扣）。建议从基础单品开始尝试，逐步找到适合自己的融合方式。',
      },
    },
    {
      '@type': 'Question',
      name: '亚洲和欧美美妆理念的主要区别是什么？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '亚洲美妆（以K-Beauty为代表）追求精致完美的水光肌效果，强调多层护肤和精细底妆；而欧美美妆（以法式为代表）崇尚"不完美的优雅"，注重展现皮肤的真实质感。两种理念可以融合——借鉴韩式的精细护肤和法式的减法思维，打造最适合自己的妆容。',
      },
    },
    {
      '@type': 'Question',
      name: '亚欧风格志提供哪些内容？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '亚欧风格志围绕三大核心板块提供深度内容：时尚穿搭（跨文化混搭指南、单品解析、趋势分析）、美妆潮流（护肤理念对比、妆容技巧、产品测评）、生活方式（家居美学、饮食文化、旅行灵感）。每周更新原创深度文章。',
      },
    },
  ],
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: '首页',
      item: 'https://shenshang003.cn',
    },
  ],
};

export default function Home() {
  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <Hero />
      <FeaturedArticles />
      <CategoryGrid />
      <LatestArticles />
      <Newsletter />
    </main>
  );
}